import {createSelector} from '@ngrx/store';
import {AppState} from '../states/app.state';

export class ConfirmDialogSelectors {
  private static select = {
    confirmDialog: (state: AppState) => state.confirmDialog,
  };

  public static isConfirmDialogOpen = createSelector(this.select.confirmDialog, data => data?.isOpen ?? false);

  public static confirmDialogTitle = createSelector(this.select.confirmDialog, data => data?.title ?? '');

  public static confirmDialogText = createSelector(this.select.confirmDialog, data => data?.text ?? '');
}
